export default {
  namespaced: true,

  state: {
    alert: {
      show: false,
      title: '',
      type: ''
    },
    redirect: ''
  },

  mutations: {
    /**
     * Set alert data
     * @param {Object} state vuex state
     * @param {Object} data Alert data
     * @param {Boolean} data.show Show or hide alert
     * @param {String} data.title Alert title
     * @param {'info'|'success'|'warning'|'error'} data.type Alert type
     */
    alert (state, data) {
      Object.assign(state.alert, data)
    },

    /**
     * Set redirect route
     * @param {Object} state vuex state
     * @param {String} route Full route path
     */
    redirect (state, route) {
      state.redirect = route
    }
  }
}
